import * as React from 'react';
import {
    RadioButtonWithLabelGroupWidget,
    TabStyles,
    DropdownButtonType,
    SingleSelectDropdown,
    ListItem,
    List,
    ListProps
} from '@tableau/widgets';
import { cssClass } from '~src/style';
import { Messages } from '~src/codegen/Localize';
import { IOAuthCredential } from '~src/ts/ServerApi/types/IOAuthCredential';

import _ = require('underscore');

const option: string = cssClass('edit-oauth-connection', 'embedded-option', {
    marginBottom: TabStyles.Sizing.BaseUnit * 2,
});

const optionText: string = cssClass('edit-oauth-connection', 'option-text', {
    marginBottom: TabStyles.Sizing.BaseUnit,
});

const optionSubText: string = cssClass('edit-oauth-connection', 'option-subtext', {
    color: TabStyles.Typography.Color.Secondary
});

const authenticationLabel: string = cssClass('edit-oauth-connection', 'authentication-label', {
    marginTop: TabStyles.Sizing.BaseUnit * 3,
    marginBottom: TabStyles.Sizing.BaseUnit * 2,
    fontWeight: 'bold'
});

export type EditOAuthConnectionDialogEmbeddedToggleProps = Readonly<{
    credentialNoValueOptionText: string;
    currentConnectionTypeDisplayName: string;
    addNewOAuthCredentialOptionValue: string;
    credentialId: string;
    credentials: IOAuthCredential[];
    credentialOption: string;
    handleToggleChange: (isPasswordEmbedded: boolean) => void;
    handleCredentialIdChange: (newCredentialId: string) => void;
}>;

export function EditOAuthConnectionDialogEmbeddedToggle(props: EditOAuthConnectionDialogEmbeddedToggleProps) {

    const renderOAuthCredentialOption = (): React.ReactNode => {
        return (
            <div className={option}>
                <div className={optionText}>{Messages.editDataConnections_generic_embedCredential()}</div>
                {renderOAuthCredentialOptionSelector()}
                <label className={optionSubText}>{Messages.editDataConnections_generic_describeEmbedCredential()}</label>
            </div>
        );
    };

    function getNameForIOAuthCredentialId(value: string, items: ListItem[]): React.ReactNode {
        if (!items.find(item => item.value === value)) {
            return props.credentialNoValueOptionText || Messages.selectOAuthCredential();
        } else {
            return items.find(item => item.value === value).content;
        }
    }

    function getIOAuthCredentialIdsList(ioauthCredentials: IOAuthCredential[]): ListItem[] {
        const items: ListItem[] = [];
        if (ioauthCredentials) {
            ioauthCredentials.map((ioauthCredential) => {
                items.push({ value: ioauthCredential.id, content: ioauthCredential.role ? ioauthCredential.username + (ioauthCredential.role && ' (' + ioauthCredential.role + ')') : ioauthCredential.username });
            });
        }
        return items;
    }

    const renderOAuthCredentialOptionSelector = (): React.ReactNode => {
        if (props.credentialOption !== 'oauth') {
            return null;
        }

        let items: ListItem[] = [];
        if (props.credentials) {
            items = getIOAuthCredentialIdsList(props.credentials);
        }
        if (props.addNewOAuthCredentialOptionValue) {
            items.push({ value: props.addNewOAuthCredentialOptionValue, content: Messages.addOAuthCredential({ CONNECTION_TYPE_NAME: props.currentConnectionTypeDisplayName }) });
        }
        const listProps: ListProps = { items };

        return (
            <SingleSelectDropdown
                label=''
                list={<List {...listProps} />}
                onChange={props.handleCredentialIdChange}
                type={DropdownButtonType.Outline}
                value={props.credentialId}
                style={{ marginBottom: TabStyles.Sizing.BaseUnit }}
            >
                {getNameForIOAuthCredentialId(props.credentialId, items)}
            </SingleSelectDropdown>
        );
    };

    const renderNoAuthOption = (): React.ReactNode => {
        const option: string = cssClass('edit-oauth-connection', 'no-auth-option', {
            marginBottom: TabStyles.Sizing.BaseUnit * 2,
        });
        const optionText: string = cssClass('edit-oauth-connection', 'option-text', {
            marginBottom: TabStyles.Sizing.BaseUnit,
        });
        const optionSubText: string = cssClass('edit-oauth-connection', 'option-subtext', {
            color: TabStyles.Typography.Color.Secondary
        });
        return (
            < div className={option}>
                <div className={optionText}>{Messages.editDataConnections_generic_noCredential()}</div>
                <label className={optionSubText}>{Messages.editDataConnections_generic_describeNoCredential()}</label>
            </div>
        );
    };

    return (
        <>
            <div className={authenticationLabel}>{Messages.authentication()}</div>
            <RadioButtonWithLabelGroupWidget
                buttonList={[
                    {
                        label: renderOAuthCredentialOption(),
                        testId: 'embedded',
                        value: true,
                        disabled: (!props.credentials || props.credentials.length === 0) && !props.addNewOAuthCredentialOptionValue,
                    },
                    {
                        label: renderNoAuthOption(),
                        testId: 'no-auth',
                        value: false,
                    },
                ]}
                checkedIndex={props.credentialOption === 'oauth' ? 0 : 1}
                handleChange={(value) => props.handleToggleChange(value)}
            />
        </>
    );
}
